import { Css } from "../assets";

  
  export let css = [
    {
      videoId: "DBsLXTENmuQ",
      time: "12:24",
      icon: Css,
      url: "css-introduction",
      heading: "What is CSS | Class(1)",
      description: "Gain an understanding of what CSS (Cascading Style Sheets) is in this introductory class.",
    },
    {
      videoId: "DUxqs7BbjLA",
      time: "10:24",
      icon: Css,
      url: "css-text-property-tutorial",
      heading: "CSS text Property tutorial | Class(2)",
      description: "Learn how to use the text property in CSS to style text content.",
    },
    {
      videoId: "cbTkjXhfZMw",
      time: "19:39",
      icon: Css,
      url: "css-div-tag-in-html",
      heading: "Div tag in HTML with CSS property | (3)",
      description: "Explore how to apply CSS properties to the div tag in HTML for enhanced styling.",
    },
    {
      videoId: "L-C14n6J_kM",
      time: "15:25",
      icon: Css,
      url: "css-display-block-and-display-inline",
      heading: "Display Block and Display Inline Class(4)",
      description: "Understand the difference between the display block and display inline CSS properties.",
    },
    {
      videoId: "mlIEe2mB1Ew",
      time: "22:23",
      icon: Css,
      url: "css-position-property-relative-&-absolute",
      heading: "CSS Position Property | relative & absolute (5)",
      description: "Master the position property in CSS and learn how to use relative and absolute positioning.",
    },
    {
      videoId: "4EjJAY6ADJo",
      time: "18:42",
      icon: Css,
      url: "css-overflow-property",
      heading: "CSS Overflow Property Class (6)",
      description: "Discover how to control overflowing content using the CSS overflow property.",
    },
    {
      videoId: "nfEpcB-Cwgo",
      time: "13:07",
      icon: Css,
      url: "css-flexbox-tutorial",
      heading: "CSS Flexbox tutorial Class (7)",
      description: "Learn how to use CSS Flexbox to create flexible and responsive layouts.",
    },
    {
      videoId: "Y1fPafLdM8s",
      time: "30:18",
      icon: Css,
      url: "css-media-queries-explained",
      heading: "Media Queries Explained",
      description: "Get an explanation of media queries and their role in creating responsive web designs.",
    },
  ];